import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FormDrawer from "src/components/Form/FormDrawer";
import { updateContractStatus } from "src/store/contract-status/saga";
import { ContractStatusDetailDto } from "src/store/contract-status/type";
import * as Yup from "yup";

const ContractStatusEditForm = ({
  data,
  onHide,
  open,
  onSuccessClick,
}: {
  data: ContractStatusDetailDto;
  onSuccessClick: (message: string) => void;
  onHide: () => void;
  open: boolean;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <FormDrawer
        drawerProps={{
          isOpen: open,
          onHide: onHide,
          title: t("Contract.Status.EditFormTitle").toString(),
        }}
        onHide={onHide}
        loader
        initialValues={{
          Id: data.Id,
          Name: data.Name,
          Translates: data.Translates.map((x) => {
            return {
              LanguageId: x.LanguageId,
              Title: x.Name,
            };
          }),
        }}
        onSubmit={(values) => {
          dispatch(
            updateContractStatus({
              payload: {
                onSuccess: (message, payload) => {
                  onHide();
                  onSuccessClick(message);
                },
                onError: (message) => {
                  toast.error(message, {
                    theme: "colored",
                  });
                },
              },
              id: data.Id,
              body: values,
            })
          );
        }}
        validationSchema={Yup.object().shape({
          Name: Yup.string().required(t("Validation.Required").toString()),
          Translates: Yup.array(
            Yup.object({
              Name: Yup.string().required(t("Validation.Required").toString()),
            })
          ),
        })}
        multilanguageinputs={[
          {
            field: "Name",
            label: t("Contract.Status.Name").toString(),
          },
        ]}
      />
    </React.Fragment>
  );
};
export default ContractStatusEditForm;
